import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoTablet = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "outline-flat",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: currentColor;\n        stroke-width: 0px;\n      }\n    " }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 29.95,
				y: 8.5,
				width: 4.1,
				height: 3
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 26.9,
				y: 51.93,
				width: 10.21,
				height: 3
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M52,62.5H10.5v-3h41.5c1.93,0,3.5-1.57,3.5-3.5V13.75h3v42.25c0,3.58-2.92,6.5-6.5,6.5Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M8.5,50.5h-3V8c0-3.58,2.92-6.5,6.5-6.5h41.5v3H12c-1.93,0-3.5,1.57-3.5,3.5v42.5Z"
			})
		] }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: -10.82,
			y: 30.5,
			width: 85.64,
			height: 3,
			transform: "translate(-13.25 32) rotate(-45)"
		})
	]
});
export default SvgNoTablet;
